/**
 * Create Event page translations
 * 
 * This file contains translations for the Create Event page.
 */

import { CreateEventTranslationType } from './types';

// English translations
export const enCreateEvent: CreateEventTranslationType = {
  createEvent: {
    title: "Create Event",
    subtitle: "Start tracking expenses with your group",
    form: {
      eventName: {
        label: "Event Name *",
        placeholder: "e.g., Trip to Bali, Teambuilding",
        required: "Please provide event name and at least one more participant"
      },
      description: {
        label: "Description",
        optional: "(Optional)",
        placeholder: "Add more details about your event..."
      },
      participants: {
        label: "Participants *",
        owner: "(Event Owner)",
        placeholder: {
          empty: "Add participant names...",
          more: "Add another..."
        },
        paste: "Paste names",
        pasteHint: "Paste names from clipboard",
        add: "Add",
        help: "Press Enter to add • Backspace to remove last • Use commas to separate multiple names",
        added_one: "participant added",
        added_other: "participants added"
      }
    },
    buttons: {
      create: "Create Event",
      creating: "Creating Event..."
    },
    errors: {
      nameRequired: "Please provide event name and at least one more participant",
      createFailed: "Failed to create event. Please try again.",
      authRequired: "Please sign in with Google to create an event."
    }
  }
};

// Vietnamese translations
export const viCreateEvent: CreateEventTranslationType = {
  createEvent: {
    title: "Tạo Sự Kiện",
    subtitle: "Bắt đầu theo dõi chi phí với nhóm của bạn",
    form: {
      eventName: {
        label: "Tên Sự Kiện *",
        placeholder: "Ví dụ: Chuyến đi Bali, Teambuilding",
        required: "Vui lòng cung cấp tên sự kiện và ít nhất một người tham gia khác"
      },
      description: {
        label: "Mô Tả",
        optional: "(Tùy chọn)",
        placeholder: "Thêm chi tiết về sự kiện của bạn..."
      },
      participants: {
        label: "Người Tham Gia *",
        owner: "(Chủ Sự Kiện)",
        placeholder: {
          empty: "Thêm tên người tham gia...",
          more: "Thêm người khác..."
        },
        paste: "Dán tên",
        pasteHint: "Dán danh sách tên từ clipboard",
        add: "Thêm",
        help: "Nhấn Enter để thêm • Backspace để xóa cuối cùng • Sử dụng dấu phẩy để phân tách nhiều tên",
        added_other: "người tham gia đã thêm"
      }
    },
    buttons: {
      create: "Tạo Sự Kiện",
      creating: "Đang Tạo Sự Kiện..."
    },
    errors: {
      nameRequired: "Vui lòng cung cấp tên sự kiện và ít nhất một người tham gia khác",
      createFailed: "Không thể tạo sự kiện. Vui lòng thử lại.",
      authRequired: "Vui lòng đăng nhập bằng Google để tạo sự kiện."
    }
  }
};